var MX_METHODS = {"pellet": {"name": "Pellet Grill", "fuel": "Kiawe Pellets", "setup": {"lowslow": "Set the dial to the pit temp below, lid closed. Use Super Smoke / smoke mode if your grill has it.", "hotfast": "Run the grill wide open (450-500F) or use the direct-flame sear slide.", "roast": "Set the dial to the pit temp below and let the controller hold it.", "plank": "Set 400F, soaked plank straight on the grates.", "cure": "Lowest setting - hold 160-180F pit temp."}, "load": {"lowslow": "Full hopper - figure 1-2 lb of pellets per hour at 225F", "hotfast": "~3 lb of pellets per hour wide open", "roast": "1.5-2 lb of pellets per hour", "plank": "A few lb in the hopper is plenty", "cure": "Under 1 lb per hour at the low end"}, "extra": "Want a heavier smoke layer? Run a smoke tube filled with Kiawe Chips alongside."}, "charcoal": {"name": "Charcoal Grill (Kettle)", "fuel": "Kiawe Lump Charcoal + 2-3 Kiawe Chunks on the coals", "setup": {"lowslow": "Bank lit lump to one side (two-zone), meat on the cool side, bottom vent cracked, top vent half. Add 2-3 kiawe chunks on the coals - lump gives heat, chunks give the smoke.", "hotfast": "Full chimney of lump spread hot, cook direct. Toss on a chunk or a handful of chips right before the meat.", "roast": "Two-zone fire, meat on the indirect side, lid on, vents set to hold the pit temp below. Chunks on the coals for smoke.", "plank": "Medium two-zone fire, soaked plank over the cool side, lid on.", "cure": "Small snake of lump around the kettle edge, 1-2 chunks spaced along it, vents nearly closed - creep along at 160-200F."}, "load": {"lowslow": "Half chimney lit over a bed of unlit lump (minion method) + 3-4 chunks; add a chunk every hour", "hotfast": "One full chimney of lump + 1 chunk or a handful of chips", "roast": "3/4 chimney banked two-zone + 2 chunks", "plank": "Half chimney, two-zone", "cure": "A dozen lumps laid in a snake + 2 chunks spaced along it"}, "extra": "Rule of thumb: lump = fire, chunks = flavor. Never skip the chunks on charcoal."}, "kamado": {"name": "Kamado / Ceramic", "fuel": "Kiawe Lump Charcoal + Kiawe Chunks buried in the lump", "setup": {"lowslow": "Fill the bowl with lump, bury 2-3 chunks at different depths, heat deflector in, vents barely open - a kamado will hold the pit temp below all day.", "hotfast": "No deflector, vents wide open, let the dome climb - kiawe lump loves 600F+.", "roast": "Deflector in, vents set for the pit temp below, chunks buried mid-load.", "plank": "Deflector in at 400F, soaked plank on the grate.", "cure": "Tiny lump load, one chunk, vents at a whisker - hold 160-200F."}, "load": {"lowslow": "Full bowl of lump + 3 chunks buried at depths - you will have leftover fuel", "hotfast": "Full bowl, vents wide", "roast": "Full bowl + 2 chunks mid-load", "plank": "Half bowl", "cure": "Quarter bowl + 1 chunk"}, "extra": "Bury chunks at different depths so fresh smoke keeps coming as the lump burns down."}, "offset": {"name": "Offset Smoker", "fuel": "Kiawe Chunks over a lump bed", "setup": {"lowslow": "Start a lump bed in the firebox, then feed kiawe chunks for thin blue smoke. Keep the fire small and hot - dirty white smoke means it is starved.", "hotfast": "Sear over the firebox grate or build a hot open chunk fire.", "roast": "Run the pit at the temp below with a clean small fire, meat mid-chamber.", "plank": "Run the pit at 375-400F, plank in the main chamber.", "cure": "Tiny fire, damper play - hold 160-200F in the chamber."}, "load": {"lowslow": "A chimney of lump to start + a chunk every 30-45 minutes for the whole cook", "hotfast": "A hot open fire of 5-6 chunks", "roast": "Small clean fire + a chunk every 45 minutes", "plank": "Small fire, 2-3 chunks", "cure": "The smallest fire you can keep alive - half chunks"}, "extra": "Preheat your next chunk on top of the firebox so it ignites clean when you feed it."}, "gas": {"name": "Gas Grill", "fuel": "Kiawe Chips in a smoke tube, or a Kiawe Chunk wrapped in foil (poke holes) on the burner", "setup": {"lowslow": "Light one burner, meat over the dead burners. Run a smoke tube of chips, or foil-wrap 2 kiawe chunks (holes poked) on the lit burner - chunks smolder about an hour each, half the refills.", "hotfast": "All burners high. Chips in a foil pouch, or better: one kiawe chunk wrapped in foil with holes poked, set right on a burner - it smolders about an hour.", "roast": "Outer burners on, meat in the middle, tube smoking in a back corner.", "plank": "Medium heat, soaked plank over a lit burner until it starts to crackle, then food on.", "cure": "One burner at its lowest, tube smoking, thermometer watching - gas runs hot, stay under 200F."}, "load": {"lowslow": "A 12-inch smoke tube holds enough chips for 4-5 hours; refill for long cooks", "hotfast": "One foil pouch of chips = ~30 min of smoke; one foil-wrapped chunk = ~1 hr", "roast": "One tube, lit at the start", "plank": "The plank is the smoke - chips optional", "cure": "One tube, half-filled, relit as needed"}, "extra": "Gas gives you control; the chips give you the island. Keep the lid closed - every peek costs smoke."}, "imu": {"name": "Imu / Ground Pit", "fuel": "Kiawe wood burned to coals over lava rocks, banana + ti leaves for wrapping", "setup": {"lowslow": "Dig the pit, line it with stones, burn a kiawe fire 2-3 hrs until the rocks glow. Rake the coals, lay banana stalks and leaves over the stones, set the leaf-wrapped meat on, cover with more leaves, wet burlap, then earth. No peeking - the pit holds a steamy 250-300F for 6-12 hrs.", "roast": "Same pit, lighter bury: wrap birds or smaller cuts in ti and banana leaves, mound fewer stones and coals, 2-4 hrs under the earth."}, "load": {"lowslow": "A full burn-down: enough kiawe to leave a deep glowing coal bed over every stone", "roast": "Half the burn - coals over half the stones"}, "extra": "The imu is steam plus smoke - the leaves do the basting. This is the original kiawe cook, the way Kalua pig has been made for centuries."}, "parrilla": {"name": "Parrilla / Asado", "fuel": "Kiawe wood burned down to coals, fed under the grate (lump works too)", "setup": {"lowslow": "Asado style: burn kiawe down in a brasero, shovel a thin bed of coals under the meat and feed a few more every 20-30 minutes. Low, patient, constant.", "hotfast": "Thick coal bed, grate cranked low - the parrilla sear is the best sear there is.", "roast": "Moderate coal bed, grate raised high, meat far from the fire - or splay whole animals on the cross (asador) leaning over the coals.", "plank": "Moderate coals, grate mid-height, soaked plank on top.", "cure": "A whisper of coals at the far end of the grate, meat at the other - the parrilla can creep low if you starve it."}, "load": {"lowslow": "Keep a side fire burning - shovel fresh coals under every 20-30 min for the whole cook", "hotfast": "One full burn-down of splits or a chimney and a half of lump", "roast": "Steady side fire, moderate shovel feeds", "plank": "Small coal bed", "cure": "A dozen coals at a time, replenished"}, "extra": "The Argentine way and the Hawaiian way agree on everything that matters: real wood, real coals, no lighter fluid, no hurry."}, "pitgrill": {"name": "Open Pit Grill (Santa Maria)", "fuel": "Kiawe splits or lump burned to coals in the pit", "setup": {"lowslow": "Crank the grate high, keep a modest coal bed, feed a split every 30-45 minutes. The open pit breathes - watch your temps at the meat, not the fire.", "hotfast": "Grate low over a full glowing bed - the Santa Maria crank handle is your throttle.", "roast": "Grate mid-height over an even bed, rotate the meat as the wind moves the heat.", "plank": "Grate high, soaked plank over the coals.", "cure": "Tiny coal bed at one end, meat at the other end of the grate, grate at full height."}, "load": {"lowslow": "A split every 30-45 min after the initial burn-down", "hotfast": "Full burn-down of 6-8 splits or two chimneys of lump", "roast": "Moderate bed + a split per hour", "plank": "Small even bed", "cure": "Coals by the shovelful, sparingly"}, "extra": "Santa Maria barbecue was born from California rancho cooking - the same open-fire tradition the paniolo carried in Hawaii. Kiawe on an open pit is both histories at once."}, "pizzaoven": {"name": "Pizza Oven (backyard or masonry)", "fuel": "Kiawe Splits or Chunks in the firebox - whatever your oven burns", "setup": {"hotfast": "Backyard oven (the Costco kind): run kiawe chunks or splits in the firebox wide open until the stone reads 650-750F on an IR gun - most hit it in 20-30 minutes. Masonry dome: fire with splits 1-1.5 hrs until the ceiling soot burns white, then rake the coals to one side and cook on the floor beside the fire.", "roast": "Backyard oven: throttle the fire back and door-gap it to hold 350-500F, turning the food often - small ovens have hot corners. Masonry dome: let the fire fall to a coal bed, door cracked; the falling oven holds the roast window for hours.", "lowslow": "This one is a masonry move - small backyard ovens can't idle at 220. In a dome: after the evening's cooking, rake the coals, lay on one kiawe split, and seal the door. It creeps down through 300F overnight and still holds 200-250F in the morning - meat in at midnight is done for lunch.", "plank": "Either oven at 375-400F, soaked plank on the stone away from the fire side.", "cure": "Masonry only: a day-after dome at 160-200F with one smoldering kiawe chunk is a ready-made curing chamber. IR gun the floor and crack the door to steer it."}, "load": {"hotfast": "Backyard oven: a few chunks, fed as it burns. Dome: 4-6 splits to fire it, a split an hour to hold", "roast": "The burn-down from pizza - little or no new wood", "lowslow": "One split on raked coals, door sealed (masonry)", "plank": "Falling heat - nothing new", "cure": "One chunk, smoldering (masonry)"}, "extra": "Any oven with a stone floor and a real fire counts - the $400 backyard box and the crane-lifted Italian dome run the same kiawe. The masonry bonus: it's a heat battery. Fire it once, cook for two days - pizza the first night, roasts as it falls, jerky on the embers."}, "plank": {"name": "Plank (any grill)", "fuel": "Kiawe Grilling Planks", "setup": {"plank": "Soak the plank 1 hour. Grill at 375-400F indirect, food on the plank, lid down. The plank should smolder at the edges, not flame - keep a spray bottle handy. Reuse it until it is half charcoal, then break it up and smoke with it."}, "load": {"plank": "One plank - reusable 2-3 cooks"}, "extra": "Add a small handful of Kiawe Chips to the fire for a second layer of smoke."}};
  var MX_SPECIES = [{"id": "beef", "name": "Beef", "cat": "Beef", "cuts": [{"name": "Brisket (full packer)", "style": "lowslow", "pit": "220-225F", "internal": "203F - probe slides like butter", "time": "12-16 hrs", "note": "220 is the number - any hotter and you're not smoking, you're just cooking with smoke on it. Wrap in butcher paper when the bark sets (~165F). Rest a minimum of 1 hour."}, {"name": "Chuck Roast", "style": "lowslow", "pit": "220-225F", "internal": "205F pulled", "time": "8-10 hrs", "note": "The poor man's brisket - shreds into the best sandwiches on earth."}, {"name": "Beef Short Ribs (plate)", "style": "lowslow", "pit": "220-235F", "internal": "200-205F probe-tender", "time": "8-9 hrs", "note": "Brisket on a stick. No wrap - let the bark go dark."}, {"name": "Beef Back Ribs", "style": "lowslow", "pit": "220-235F", "internal": "Probe-tender, bend test", "time": "4-5 hrs", "note": "The ribeye's own ribs - less meat than plate ribs, but what's there is rib-cap sweet and right against the bone. Glaze island-style in the last 30 minutes only."}, {"name": "Beef Tongue (Lengua)", "style": "lowslow", "pit": "220-225F", "internal": "205F, probe slides clean", "time": "Simmer 2-3 hrs + smoke 2-3 hrs", "note": "The best smoker cut nobody buys. Simmer first until the skin peels away, then into kiawe smoke for bark and depth. Slice thin for tacos - barbacoa and the imu are the same buried-fire tradition, and kiawe is a true mesquite."}, {"name": "Beef Cheeks", "style": "lowslow", "pit": "220-235F", "internal": "205F, jiggles like brisket point", "time": "5-6 hrs", "note": "Barbacoa's star. Smoke to the stall, then wrap with a splash of stock until they surrender. Shreds into the best taco meat that ever came off a smoker."}, {"name": "Oxtail", "style": "lowslow", "pit": "220-225F", "internal": "Falling off the bone, probe-tender", "time": "Smoke 3 hrs + braise 2-3 hrs", "note": "Hawaii already loves oxtail - this is the soup pot meeting the smoker. Smoke naked 3 hours, then braise with ginger, star anise, and shoyu until the meat lets go of the bone. Serve over rice with chili pepper water."},{"name": "Prime Rib", "style": "roast", "pit": "250F", "internal": "Pull 120F, rests to 128-130F", "time": "3-4 hrs", "note": "Sear at the end for crust. Salt it the night before, uncovered in the fridge."}, {"name": "Tri-Tip", "style": "hotfast", "pit": "225F, then screaming-hot sear", "internal": "130-135F medium-rare", "time": "1.5-2 hrs", "note": "Reverse sear: smoke to 118F, rest 10, sear 90 sec/side. Slice across BOTH grain directions."}, {"name": "Tomahawk / Bone-In Ribeye", "style": "hotfast", "pit": "225F, then sear", "internal": "130-135F medium-rare", "time": "2 hrs", "note": "Pull at 118F, sear hard over open kiawe fire for the crust."}, {"name": "Ribeye / NY Strip", "style": "hotfast", "pit": "450-500F direct", "internal": "130-135F medium-rare", "time": "10-15 min", "note": "Flip every 45 seconds for an even crust. Rest 5 min."}, {"name": "Picanha", "style": "hotfast", "pit": "225F, then sear fat-side down", "internal": "130F medium-rare", "time": "1.5 hrs", "note": "Score the fat cap - the kiawe-seared fat is the whole point."}, {"name": "Beef Heart (Anticucho)", "style": "hotfast", "pit": "450F+ direct", "internal": "130-135F medium-rare", "time": "10-15 min + overnight marinade", "note": "Peru's street-fire classic from the far edge of the same ocean. Trim the silverskin, cube, skewer, marinate overnight, char fast. Eats like lean ribeye - the gateway odd cut."}, {"name": "Burgers", "style": "hotfast", "pit": "450F direct", "internal": "160F (USDA - ground meat)", "time": "10-12 min", "note": "Ground meat must hit 160F - no pink math on burgers."}, {"name": "Beef Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends and cracks, never snaps", "time": "Overnight marinade + 4-6 hrs", "note": "Slice 1/4 inch. Safety step: bring meat to 160F at the start (10 min at 275F), then drop low and dry. Shoyu-pineapple marinade keeps it on brand."}]}, {"id": "pork", "name": "Pork", "cat": "Pork", "cuts": [{"name": "Butt / Shoulder (Kalua-style)", "style": "lowslow", "pit": "225-250F", "internal": "203F, bone pulls clean", "time": "10-14 hrs", "note": "Hawaiian coarse sea salt, banana leaves if you can get them - that is the imu move. Shred over rice."}, {"name": "Whole Pig", "style": "lowslow", "pit": "250-275F", "internal": "195F in the shoulders, 165F+ everywhere", "time": "8-12 hrs (75-100 lb pig)", "note": "Butterfly and splay it flat, skin-side up first, flip for the final crisp. Salt inside heavily the night before. This is the luau cook - invite everyone you have ever met."}, {"name": "Baby Back Ribs (island glazed)", "style": "lowslow", "pit": "225-250F", "internal": "Probe-tender ~200F, bend test", "time": "5 hrs", "note": "Guava or pineapple glaze in the last 30 min - sugar burns, glaze late."}, {"name": "St. Louis / Spare Ribs", "style": "lowslow", "pit": "225-250F", "internal": "Probe-tender, bend test", "time": "6 hrs", "note": "3-2-1 works: 3 smoke, 2 wrapped sweet, 1 glazed."}, {"name": "Pork Belly Burnt Ends", "style": "lowslow", "pit": "250F", "internal": "200F cubes", "time": "5-6 hrs", "note": "Cube, smoke 3 hrs, then pan with glaze until candy."}, {"name": "Thick-Cut Chops", "style": "hotfast", "pit": "225F, then sear", "internal": "145F + 3 min rest", "time": "45 min", "note": "Brine first and they cannot dry out."}, {"name": "Tenderloin", "style": "roast", "pit": "375F", "internal": "145F + rest", "time": "35-45 min", "note": "Glaze with guava jam in the last 10 minutes."}]}, {"id": "lamb", "name": "Lamb", "cat": "Lamb", "cuts": [{"name": "Rack of Lamb", "style": "hotfast", "pit": "225F, then sear", "internal": "125-130F medium-rare", "time": "45 min", "note": "Reverse sear: smoke to 115F, rest, then sear the fat cap hard. Kiawe's sweetness loves lamb fat."}, {"name": "Leg of Lamb (bone-in)", "style": "roast", "pit": "325F", "internal": "130-135F sliced", "time": "2-3 hrs", "note": "Garlic slivers pushed into the meat, rosemary optional, rest 20 minutes before carving."}, {"name": "Whole Lamb", "style": "roast", "pit": "Moderate open fire, 275-325F at the meat", "internal": "145F legs / shoulders probe-tender ~175F", "time": "4-5 hrs", "note": "The asado al asador cook - splayed on a cross or spit, leaning over kiawe coals, basted with salmuera (salty brine) every 30 minutes. Patience and ember management are the whole recipe."}, {"name": "Shoulder (pulled)", "style": "lowslow", "pit": "225-250F", "internal": "195-203F, shreds clean", "time": "8-10 hrs", "note": "The brisket of lamb - wrap at the stall, pull it rich and deep. Incredible over rice with mint and chili."}, {"name": "Lamb Flaps / Ribs (Sipi)", "style": "lowslow", "pit": "250-275F", "internal": "Rendered and probe-tender", "time": "3-4 hrs", "note": "The Pacific's favorite lamb cut - Tonga runs on sipi. Fatty belly ribs smoked until the fat renders, then flashed over flame with a shoyu glaze."}, {"name": "Loin Chops", "style": "hotfast", "pit": "450F direct", "internal": "125-130F", "time": "8-10 min", "note": "Two minutes a side, stand them on the fat edge at the end to crisp it."}]}, {"id": "chicken", "name": "Chicken", "cat": "Poultry", "cuts": [{"name": "Whole Bird (True Smoked)", "style": "lowslow", "pit": "275-325F", "internal": "165F breast / 175F thigh", "time": "2.5-3.5 hrs", "note": "Chicken is the exception to 220 low-and-slow: poultry needs a hotter smoke so the skin renders and the bird climbs through the temps fast enough to be safe. Brine overnight first (1/2 cup salt + 1/2 cup sugar per gallon), pat dry, and smoke until the skin goes mahogany."}, {"name": "Whole Bird", "style": "roast", "pit": "375-400F", "internal": "165F breast / 175F thigh", "time": "1.5 hrs", "note": "Spatchcock it - 25% faster, more even, more crispy skin. Brine overnight first and it cannot dry out."}, {"name": "Thighs (Huli Huli)", "style": "roast", "pit": "400F", "internal": "175-185F", "time": "45 min", "note": "Shoyu-pineapple glaze, flip repeatedly - huli means turn."}, {"name": "Wings", "style": "hotfast", "pit": "425F", "internal": "185F - crispy", "time": "40 min", "note": "High heat renders the skin. Toss in glaze after, never during."}, {"name": "Breast", "style": "roast", "pit": "375F", "internal": "160F, rests to 165F", "time": "30-40 min", "note": "Brine 2 hrs first. Pull at 160 and let carryover finish it."}]}, {"id": "turkey", "name": "Turkey", "cat": "Poultry", "cuts": [{"name": "Whole Bird", "style": "roast", "pit": "325F", "internal": "165F breast / 175F thigh", "time": "~13 min per lb", "note": "Dry-brine 24-48 hrs. Kiawe's mild sweetness is built for turkey."}, {"name": "Breast", "style": "roast", "pit": "325F", "internal": "Pull 160F, rests to 165F", "time": "2-2.5 hrs", "note": "Brine it - breast has no fat safety net."}, {"name": "Legs", "style": "lowslow", "pit": "275F", "internal": "175-185F", "time": "3-4 hrs", "note": "State-fair style: brine, smoke low, eat like a Viking."}, {"name": "Turkey Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends, never snaps", "time": "Overnight marinade + 4 hrs", "note": "Breast only, sliced thin with the grain. Poultry safety: bring to 165F at the start (10 min at 300F), then drop low and dry."}]}, {"id": "duck", "name": "Duck", "cat": "Poultry", "cuts": [{"name": "Breast", "style": "hotfast", "pit": "450F direct, skin down first", "internal": "135F medium-rare", "time": "8-10 min", "note": "Cooks like steak: sear skin-side until crisp, finish medium-rare, rest 3 min."}, {"name": "Whole Bird", "style": "roast", "pit": "350F", "internal": "165F thigh", "time": "1.5 hrs", "note": "Wild birds are lean - baste often, or bard with bacon."}]}, {"id": "goose", "name": "Goose", "cat": "Poultry", "cuts": [{"name": "Breast", "style": "hotfast", "pit": "450F direct, skin down first", "internal": "135F medium-rare", "time": "10-12 min", "note": "Like a steak, never like chicken - well-done goose eats like liver. Score and render the skin slow."}, {"name": "Whole Bird", "style": "roast", "pit": "325-350F", "internal": "165F breast / 175F thigh", "time": "2.5-3 hrs", "note": "Prick the skin all over before cooking - goose carries serious fat and it must render out. Save every drop that drips: goose fat is liquid gold for potatoes."}, {"name": "Legs", "style": "lowslow", "pit": "275F", "internal": "195F, shreddable", "time": "3 hrs", "note": "Legs are all connective tissue - low and slow until they pull, then shred into rice bowls."}, {"name": "Goose Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends, never snaps", "time": "Overnight marinade + 4-5 hrs", "note": "A waterfowler classic - dark, rich, better than beef. Same 160F safety step, then low kiawe smoke."}]}, {"id": "pheasant", "name": "Pheasant", "cat": "Poultry", "cuts": [{"name": "Whole Bird", "style": "roast", "pit": "350-375F", "internal": "160F breast", "time": "1 hr", "note": "Brine overnight and bard with bacon - overcooked pheasant is cardboard."}, {"name": "Breast", "style": "roast", "pit": "350F", "internal": "155-160F", "time": "25 min", "note": "Gentle heat, butter baste, pull early."}]}, {"id": "quail", "name": "Quail", "cat": "Poultry", "cuts": [{"name": "Whole (spatchcocked)", "style": "hotfast", "pit": "425F direct", "internal": "160F", "time": "15-20 min", "note": "Glaze with guava, eat with your hands."}]}, {"id": "venison", "name": "Venison (Deer)", "cat": "Wild Game", "cuts": [{"name": "Backstrap", "style": "hotfast", "pit": "225F, then sear", "internal": "125-130F rare to medium-rare", "time": "45 min", "note": "Zero fat, zero forgiveness - never past medium. Rest well."}, {"name": "Hindquarter Roast", "style": "roast", "pit": "250F", "internal": "130-135F sliced", "time": "2-3 hrs", "note": "Slice thin against the grain. Past medium it turns to shoe."}, {"name": "Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends and cracks, never snaps", "time": "Overnight marinade + 4-5 hrs", "note": "The best jerky meat there is. Same 160F safety step as beef, then low kiawe smoke until leathery."}]}, {"id": "axis", "name": "Axis Deer", "cat": "Wild Game", "cuts": [{"name": "Backstrap", "style": "hotfast", "pit": "225F, then sear", "internal": "125-130F", "time": "45 min", "note": "The mildest, sweetest venison there is - Hawaii's axis herds are legendary eating. Treat it like beef tenderloin."}, {"name": "Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends, never snaps", "time": "Overnight + 4-5 hrs", "note": "Ultra-lean and mild - the premium jerky. 160F safety step first, then low kiawe smoke."}]}, {"id": "elk", "name": "Elk", "cat": "Wild Game", "cuts": [{"name": "Backstrap / Steaks", "style": "hotfast", "pit": "225F, then sear", "internal": "125-135F", "time": "1 hr", "note": "Hot, fast, rare-to-medium, long rest."}, {"name": "Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends, never snaps", "time": "Overnight + 4-5 hrs", "note": "Lean and perfect for it - 160F safety step first."}]}, {"id": "moose", "name": "Moose", "cat": "Wild Game", "cuts": [{"name": "Steaks", "style": "hotfast", "pit": "225F, then sear", "internal": "125-135F", "time": "1 hr", "note": "Treat like elk."}, {"name": "Roast", "style": "lowslow", "pit": "250F", "internal": "200F pulled", "time": "6-8 hrs", "note": "Big moose roasts run the brisket road - low, slow, shredded."}]}, {"id": "pronghorn", "name": "Antelope / Pronghorn", "cat": "Wild Game", "cuts": [{"name": "Backstrap", "style": "hotfast", "pit": "225F, then sear", "internal": "125-130F", "time": "45 min", "note": "Fastest-cooking big game there is - thin muscles, zero fat. Hot, fast, rare, rested."}, {"name": "Hindquarter Roast", "style": "roast", "pit": "250F", "internal": "130-135F sliced", "time": "2 hrs", "note": "The leanest of the lean - slice thin against the grain, and never past medium or it's gone."}, {"name": "Jerky", "style": "cure", "pit": "160-180F", "internal": "Bends, never snaps", "time": "Overnight + 4-5 hrs", "note": "Sage-country flavor, ultra-lean and built for it. Same 160F safety step as beef, then low kiawe smoke until leathery."}]}, {"id": "wildboar", "name": "Boar", "cat": "Wild Game", "cuts": [{"name": "Shoulder (pulled)", "style": "lowslow", "pit": "225-250F", "internal": "200F pulled - must pass 145F min", "time": "8-12 hrs", "note": "Non-negotiable: wild pork carries trichinosis risk and must pass 145F minimum - pulled at 200F you are covered twice over."}, {"name": "Ribs", "style": "lowslow", "pit": "250F", "internal": "Probe-tender, past 145F", "time": "5 hrs", "note": "Leaner than farm pork - wrap earlier, glaze sweeter."}]}, {"id": "rabbit", "name": "Rabbit", "cat": "Wild Game", "cuts": [{"name": "Whole", "style": "roast", "pit": "350F", "internal": "160F", "time": "1-1.5 hrs", "note": "Brine overnight, baste with butter, pull the loins before the legs."}]}, {"id": "bison", "name": "Bison", "cat": "Wild Game", "cuts": [{"name": "Steaks", "style": "hotfast", "pit": "225F, then sear", "internal": "125-130F", "time": "45 min", "note": "Leaner than beef - cooks a third faster than you expect."}, {"name": "Burgers", "style": "hotfast", "pit": "450F direct", "internal": "160F (ground meat)", "time": "10 min", "note": "Add a little fat or they dry - bison is lean."}]}, {"id": "salmon", "name": "Salmon", "cat": "Ocean Fish", "cuts": [{"name": "Fillet (plank)", "style": "plank", "pit": "375-400F", "internal": "125-135F medium (USDA: 145F)", "time": "25-40 min", "note": "The kiawe plank steams sweet smoke into the fish. White albumin beads = pull it now.", "plank": true}, {"name": "Whole Fish", "style": "roast", "pit": "375F", "internal": "130-135F at the spine", "time": "45 min", "note": "Stuff with lemon and herbs, score the skin, oil it well."}, {"name": "Candied Salmon / Salmon Jerky", "style": "cure", "pit": "160-175F (or cold smoke under 90F)", "internal": "145F hot-smoked, lacquered, still flexes", "time": "Overnight cure + pellicle + 3-5 hrs", "note": "Same craft, two names. Cure strips in brown sugar + salt (2:1), rinse, air-dry until tacky - that pellicle is what the smoke sticks to - then smoke low on the pellet grill or offset, basting with maple as it goes. Serious rigs can cold-smoke under 90F for the old-style hard-cure candy."}]}, {"id": "ahi", "name": "Ahi / Tuna", "cat": "Ocean Fish", "cuts": [{"name": "Steaks (seared rare)", "style": "hotfast", "pit": "As hot as your fire gets", "internal": "Rare center 110-115F (USDA: 145F)", "time": "60-90 sec per side", "note": "Sear over open kiawe flame, cold red center. Chips on the fire right before = poke-house flavor."}, {"name": "Hot-Smoked Ahi", "style": "cure", "pit": "175-200F", "internal": "145F, firm and flaky", "time": "2-hr brine + 2 hrs smoke", "note": "Brine, pellicle, low kiawe smoke - then flake it into the best smoked fish dip on the island or off it."}]}, {"id": "wahoo", "name": "Wahoo (Ono)", "cat": "Ocean Fish", "cuts": [{"name": "Fillets", "style": "hotfast", "pit": "450F direct", "internal": "130-135F", "time": "8 min", "note": "Ono means delicious - lean, dries fast. Baste with butter, pull early."}]}, {"id": "halibut", "name": "Halibut", "cat": "Ocean Fish", "cuts": [{"name": "Fillets (plank)", "style": "plank", "pit": "375F", "internal": "130-135F - pull before 140F", "time": "20-25 min", "note": "Least forgiving fish on the list - past 140F it turns to chalk.", "plank": true}]}, {"id": "walleye", "name": "Walleye", "cat": "Freshwater Fish", "cuts": [{"name": "Fillets (plank)", "style": "plank", "pit": "375F", "internal": "140-145F, flakes easily", "time": "20 min", "note": "Delicate - the plank saves them from the grate. Lemon, butter, dill.", "plank": true}]}, {"id": "striper", "name": "Striped Bass", "cat": "Ocean Fish", "cuts": [{"name": "Fillets (plank)", "style": "plank", "pit": "400F", "internal": "140-145F", "time": "25 min", "note": "Skin-on holds it together.", "plank": true}, {"name": "Whole Fish", "style": "roast", "pit": "400F", "internal": "140F at the spine", "time": "30 min", "note": "Score, stuff with citrus, grill in a basket."}]}, {"id": "crappie", "name": "Crappie", "cat": "Freshwater Fish", "cuts": [{"name": "Fillets", "style": "hotfast", "pit": "400F in a basket or foil", "internal": "140-145F", "time": "6-8 min", "note": "Thin fillets cook in minutes - quick kiss of chip smoke."}]}, {"id": "trout", "name": "Trout & Small Fish", "cat": "Freshwater Fish", "cuts": [{"name": "Hot-Smoked", "style": "cure", "pit": "175-200F", "internal": "145F, flakes at the collar", "time": "4-hr brine + 2-3 hrs", "note": "Brine 4 hrs (1 cup salt + 1 cup brown sugar per gallon), air-dry to a tacky pellicle, smoke low. Trout, kokanee, mackerel, whitefish."}, {"name": "Grilled Whole", "style": "roast", "pit": "400F", "internal": "145F", "time": "20 min", "note": "Butter, lemon, foil or basket."}]}, {"id": "shrimp", "name": "Shrimp", "cat": "Shellfish", "cuts": [{"name": "Skewers", "style": "hotfast", "pit": "450F direct", "internal": "120-130F, opaque, C-shaped", "time": "4-6 min", "note": "O-shaped = overcooked. Garlic butter at the end."}]}, {"id": "oysters", "name": "Oysters", "cat": "Shellfish", "cuts": [{"name": "Smoked in the Shell", "style": "cure", "pit": "180-200F", "internal": "Edges curled", "time": "30-45 min", "note": "Shuck, cup-side down, garlic butter in each shell. Kiawe smoke + brine is unfair."}]}, {"id": "octopus", "name": "Octopus (Tako / He'e)", "cat": "Shellfish", "cuts": [{"name": "Char-Grilled (Tako-style)", "style": "hotfast", "pit": "Simmer first, then 450F+ direct", "internal": "Tender from the simmer; charred edges from the fire", "time": "1-hr simmer + 6-8 min grill", "note": "The Hawaiian way: simmer the octopus 45-60 min until a knife slides into the thick part, dry it well, oil it, then char hard and fast over open kiawe flame. Shoyu, lemon, chili flake to finish - or chill and slice for tako poke."}, {"name": "Smoked Octopus", "style": "cure", "pit": "175-200F", "internal": "Tender, bronzed, 45-60 min in smoke", "time": "1-hr simmer + 1-hr smoke", "note": "Same simmer first, then a low kiawe smoke bath instead of the sear. Slice thin, olive oil, sea salt - it eats like the ocean's answer to charcuterie."}]}, {"id": "opihi", "name": "Opihi (Hawaiian Limpets)", "cat": "Shellfish", "cuts": [{"name": "Grilled in the Shell", "style": "hotfast", "pit": "Hot kiawe coals", "internal": "Edges curl and the butter bubbles, 2-4 min", "time": "5 min", "note": "Hawaii's most prized pupu - pickers risk the wave rocks for these. Shell-down on the coals, a drop of butter, garlic, and shoyu in each. Eat standing at the grill; they will not survive the walk to the table."}]}, {"id": "lobster", "name": "Spiny Lobster (Ula)", "cat": "Shellfish", "cuts": [{"name": "Split & Grilled", "style": "hotfast", "pit": "450F direct, shell-side down first", "internal": "135-140F, flesh opaque and just set", "time": "10-12 min", "note": "Hawaii's ula and the Baja bug are the same animal - no claws, all tail. Split lengthwise, shell down over the coals 6-8 minutes basting with garlic-shoyu butter, flip flesh-down 2 minutes for the kiss of char, done. Past 140F it turns to rubber - pull early and let the shell's heat finish it."}, {"name": "Tails, Butterflied", "style": "hotfast", "pit": "450F direct", "internal": "135-140F", "time": "8-10 min", "note": "Cut the top shell, lift the meat to sit on top piggyback-style, baste with butter and chili pepper water. The shell shields the meat from the fire and the exposed top takes the smoke."}]}];
  var mxS = null, mxP = null, mxR = null;
  function mxInit(){
    var sel = document.getElementById("mxSpecies");
    var cats = [];
    MX_SPECIES.forEach(function(s){ if(cats.indexOf(s.cat)<0) cats.push(s.cat); });
    var o = '<option value="">Pick your protein…</option>';
    cats.forEach(function(c){
      o += '<optgroup label="' + c + '">';
      MX_SPECIES.forEach(function(s){ if(s.cat===c) o += '<option value="' + s.id + '">' + s.name + '</option>'; });
      o += '</optgroup>';
    });
    sel.innerHTML = o;
  }
  function mxSpeciesPick(){
    var id = document.getElementById("mxSpecies").value;
    mxS = MX_SPECIES.filter(function(x){ return x.id===id; })[0] || null;
    mxP = null;
    var cutSel = document.getElementById("mxCut");
    if(!mxS){ cutSel.disabled = true; cutSel.innerHTML = '<option value="">Pick a protein first…</option>'; mxUpdateRigs(); mxRender(); return; }
    cutSel.disabled = false;
    var o = '';
    if(mxS.cuts.length > 1) o += '<option value="">Pick the cut…</option>';
    var groups = [["Grill & Roast",[]],["True Smoke",[]],["Cure & Preserve",[]]];
    mxS.cuts.forEach(function(c, i){
      var g = (c.style==="lowslow") ? 1 : (c.style==="cure" ? 2 : 0);
      groups[g][1].push('<option value="' + i + '">' + c.name + '</option>');
    });
    var nonEmpty = groups.filter(function(g){ return g[1].length; });
    if(nonEmpty.length > 1){
      nonEmpty.forEach(function(g){ o += '<optgroup label="' + g[0] + '">' + g[1].join('') + '</optgroup>'; });
    } else {
      mxS.cuts.forEach(function(c, i){ o += '<option value="' + i + '">' + c.name + '</option>'; });
    }
    cutSel.innerHTML = o;
    if(mxS.cuts.length === 1){ cutSel.value = "0"; mxCutPick(); }
    else { mxUpdateRigs(); mxSteps(); mxRender(); }
  }
  function mxCutPick(){
    var v = document.getElementById("mxCut").value;
    mxP = (mxS && v !== "") ? mxS.cuts[parseInt(v)] : null;
    mxUpdateRigs();
    mxSteps();
    mxRender();
  }
  function mxUpdateRigs(){
    var plankBtn = document.querySelector('.mx-rigs .rpill[data-rig="plank"]');
    var imuBtn = document.querySelector('.mx-rigs .rpill[data-rig="imu"]');
    var plankOK = mxP && (mxP.plank || mxP.style==="hotfast" || mxP.style==="roast");
    var imuOK = mxP && (mxP.style==="lowslow" || mxP.style==="roast");
    plankBtn.disabled = mxP ? !plankOK : false;
    imuBtn.disabled = mxP ? !imuOK : false;
    if(mxP && !plankOK && mxR==="plank"){ mxR=null; plankBtn.classList.remove("active"); }
    if(mxP && !imuOK && mxR==="imu"){ mxR=null; imuBtn.classList.remove("active"); }
  }
  function mxRig(btn){
    if(btn.disabled) return;
    mxR = btn.getAttribute("data-rig");
    document.querySelectorAll(".mx-rigs .rpill").forEach(function(b){ b.classList.toggle("active", b===btn); });
    mxSteps();
    mxRender();
  }
  function mxRender(){
    var card = document.getElementById("mxCard");
    if(!mxS || !mxP || !mxR){ card.classList.remove("show"); return; }
    var m = MX_METHODS[mxR];
    var style = (mxR==="plank") ? "plank" : mxP.style;
    var setup = m.setup[style] || m.setup["roast"];
    var load = m.load ? (m.load[style] || null) : null;
    var pitDisplay = mxP.pit, timeDisplay = mxP.time;
    if(mxR==="plank" && mxP.style!=="plank"){
      pitDisplay = "375-400F indirect, on the plank";
      timeDisplay = "Longer than direct - cook to temp, not the clock";
    }
    var trueSmoke = (style==="lowslow" || style==="cure" || mxR==="imu");
    var kind = trueSmoke ? '<div class="mx-kind true">True Smoking — the smoke is the cook</div>' : '<div class="mx-kind kissed">Smoke-Kissed — 350F and up is cooking, not smoking. This is grilling with island flavor added</div>';
    card.innerHTML =
      "<h3>" + mxS.name + " \u2014 " + mxP.name + " \u2014 " + m.name + "</h3>" + kind +
      '<div class="mx-fuel">Burn: ' + m.fuel + '</div>' + mxRecipeList();
    card.classList.add("show");
    card.scrollIntoView({behavior:"smooth", block:"nearest"});
  }

  function mxRecipeList(){
    var out = '';
    Object.keys(RECIPES).forEach(function(k){
      var r = RECIPES[k];
      if(r.protein !== mxS.id) return;
      if(r.cuts && r.cuts.indexOf(mxP.name) < 0) return;
      if(r.rigs && r.rigs.indexOf(mxR) < 0) return;
      out += '<button class="mx-rlink" onclick="openRecipe(\'' + k + '\')"><b>' + r.title + '</b><span>' + r.meta + ' — full recipe, printable</span></button>';
    });
    var sN2 = mxS.name.replace(/\s*\([^)]*\)/g, "").trim();
    var cN2 = mxP.name.replace(/\s*\([^)]*\)/g, "").trim();
    var comboName = (cN2.toLowerCase().indexOf(sN2.toLowerCase()) >= 0) ? cN2 : sN2 + " " + cN2;
    Object.keys(HOUSE_FLAVORS).forEach(function(v){
      var f = HOUSE_FLAVORS[v];
      out += '<button class="mx-rlink house" onclick="openHouseRecipe(\'' + v + '\')"><b>' + f.tag + ' ' + comboName + '</b><span>House recipe \u2014 origin, pairings, temps, and the full cook sequence</span></button>';
    });
    return '<div class="mx-recipes"><h4>Recipes for this exact setup</h4>' + out + '</div>';
  }
  function mxSteps(){
    var steps = document.querySelectorAll("#matrix .mx-step");
    if(steps.length===3){
      steps[0].classList.toggle("done", !!mxS);
      steps[1].classList.toggle("done", !!mxP);
      steps[2].classList.toggle("done", !!mxR);
    }
  }
  function mxReset(){
    mxS = null; mxP = null; mxR = null;
    document.getElementById("mxSpecies").value = "";
    var cutSel = document.getElementById("mxCut");
    cutSel.disabled = true; cutSel.innerHTML = '<option value="">Pick a protein\u2026</option>';
    document.querySelectorAll(".mx-rigs .rpill").forEach(function(b){ b.classList.remove("active"); b.disabled = false; });
    document.getElementById("mxCard").classList.remove("show");
    mxSteps();
  }
  document.addEventListener("DOMContentLoaded", mxInit);

  
  var RECIPES = {
 "alohapastor": {
  "title": "The Founder's Aloha Pastor",
  "meta": "Overnight marinade + 1 hr smoke + the spin \u00b7 Intermediate \u00b7 Feeds 8",
  "protein": "pork",
  "cuts": [
   "Butt / Shoulder (Kalua-style)"
  ],
  "rigs": [
   "charcoal",
   "pellet",
   "kamado",
   "offset"
  ],
  "intro": [
   "Al pastor was always halfway to Hawaii \u2014 pineapple in the marinade, a pineapple crown on the trompo. This closes the distance. The founder's two-phase cook is the whole recipe: a vertical shawarma machine gives you the true taqueria spin-and-shave, but its electric heat makes zero-smoke pastor on its own \u2014 so the stack gets its kiawe FIRST. Par-smoke the loaded skewer on the grill, then let the machine do the spinning. Smoke phase on the fire, crisp phase on the spit.",
   "Dress it one of two ways. Classic: diced white onion, cilantro, a piece of the skewer pineapple, salsa, lime \u2014 no raw tomato on a real pastor taco; tomato only lives inside the salsa. Founder's: a spoon of the pineapple pico from the Puerto Hawaii lobster \u2014 it carries the pineapple, onion, cilantro, and lime in one bowl."
  ],
  "pair": [
   {
    "t": "Salsa Roja",
    "u": "https://www.simplyrecipes.com/recipes/roasted_tomato_salsa/",
    "d": "the coast's half of the table"
   },
   {
    "t": "Homemade Corn Tortillas",
    "u": "https://www.simplyrecipes.com/recipes/homemade_corn_tortillas/",
    "d": "street-size, fresh off the comal"
   }
  ],
  "specs": [
   {
    "l": "Smoke Phase",
    "v": "220-250F over kiawe, 1 hr"
   },
   {
    "l": "Spin Phase",
    "v": "~45-60 min to the first shave"
   },
   {
    "l": "Shave",
    "v": "Crisp outer layer, thin ribbons"
   },
   {
    "l": "Burn",
    "v": "Kiawe Chunks or Chips"
   }
  ],
  "ing": [
   "3-4 lbs pork shoulder, sliced 1/4 inch thin \u2014 freeze 30 min first for clean slices",
   "Marinade: 3 guajillo + 2 ancho chiles, soaked and blended with 2 Tbsp achiote paste + 1/2 cup pineapple juice + 1/4 cup white vinegar + 4 garlic cloves + 1 tsp cumin + 1 tsp Mexican oregano + 2 tsp salt \u2014 the Hawaii turn: 2 Tbsp shoyu + 1 Tbsp grated ginger",
   "1 whole pineapple: 2 thick slabs for the skewer ends, the rest for the pico or the table",
   "Fresh street-size tortillas (4-5 inch), corn or flour, warmed \u2014 small tortillas, big stack; a pastor taco is three bites, not a burrito",
   "The classic dress: diced white onion + cilantro + skewer pineapple + salsa + lime",
   "The founder's dress: the pineapple pico (see the Puerto Hawaii Lobster recipe)",
   "Chili pepper water on the table"
  ],
  "steps": [
   "Marinate the pork slices overnight, fully coated.",
   "Build the trompo on the shawarma machine's OWN skewer: pineapple slab, pork slices threaded flat and packed TIGHT \u2014 loose stacks fall apart \u2014 pineapple slab to cap it.",
   "The kiawe phase: lay the loaded skewer in the grill, indirect, 220-250F with kiawe chunks rolling, 1 hour. No spinning needed \u2014 the smoke soaks into every layer while the stack firms up. This step is the entire reason the recipe works; the machine can't smoke.",
   "The spin: mount the skewer in the shawarma machine, element on, and let it turn until the outside goes mahogany with crisp edges \u2014 roughly 45-60 minutes to the first shave.",
   "Carve like the taqueros do: shave the crisped outer layer off in thin ribbons straight into tortillas, then let the next layer spin and crisp while everyone eats the first round. The machine keeps making more the whole meal.",
   "Dress classic or founder's. Chili pepper water for the island, salsa for the coast."
  ],
  "products": [
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   },
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ]
 },
 "smashburger": {
  "title": "The Founder's Smash Burger",
  "meta": "20 min \u00b7 Easy \u00b7 Makes 4 doubles",
  "protein": "beef",
  "cuts": [
   "Burgers"
  ],
  "rigs": [
   "charcoal",
   "gas"
  ],
  "intro": [
   "A smash burger with actual kiawe smoke in it \u2014 the thing a kitchen griddle can never do. Cast iron flat-top on the grate over kiawe lump, chips rolling on the coals, and the pineapple caramelized in the beef tallow right beside the patties. Salt, pepper, meat, fire \u2014 the founder's rules \u2014 with the islands riding on top.",
   "The griddle is the whole game: 425-450F on the surface, checked with an IR gun on the matte black seasoning (never a shiny oil spot \u2014 reflective surfaces read falsely low). Below 400 the meat steams; above 500 the tallow scorches and buries the kiawe."
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "for the extra rings"
   }
  ],
  "specs": [
   {
    "l": "Griddle",
    "v": "425-450F surface, IR gun"
   },
   {
    "l": "Per Side",
    "v": "90 seconds"
   },
   {
    "l": "Time",
    "v": "20 min"
   },
   {
    "l": "Burn",
    "v": "Kiawe lump + chips (gas: foil-wrapped chunk)"
   }
  ],
  "ing": [
   "1 1/2 lbs 80/20 ground chuck, rolled loose into 8 x 3-oz balls \u2014 do not pack them",
   "Salt and coarse black pepper, nothing else on the meat",
   "8 thin pineapple slices (about 1/4 inch), patted VERY dry",
   "8 slices American cheese",
   "4 King's Hawaiian hamburger buns",
   "Island mayo: 1/2 cup mayonnaise + 2 tsp shoyu + a splash of chili pepper water",
   "Chili pepper water (2-3 days ahead): 10-15 Hawaiian chilies (n\u012boi \u2014 Thai bird works), halved + 1 1/2 cups boiling water + 1 Tbsp vinegar + 1 tsp coarse salt",
   "A little beef tallow to start \u2014 the patties render the rest"
  ],
  "steps": [
   "Flat-top across the grate over a full chimney of kiawe lump, lid closed, 10-15 minutes to 425-450F on the surface. Gas: foil-wrapped kiawe chunk or split on a lit burner \u2014 wait until the smoke is really rolling.",
   "A handful of kiawe chips on the coals, then balls down and smash HARD for 10 seconds each \u2014 thin, ragged, lacy edges. Lid stays open from here.",
   "Salt and pepper the smashed side. 90 seconds a side \u2014 deep mahogany edges, then scrape-flip with a stiff spatula and take the crust with you. Cheese on every patty after the flip; stack into pairs.",
   "Pineapple rings down in the tallow beside the meat, 1-2 minutes a side until caramelized dark at the edges. Dry fruit caramelizes; wet fruit steams.",
   "Buns cut-side down in the tallow corner \u2014 15-20 seconds only; King's Hawaiian runs sweet and toasts fast. Island mayo both sides, double stack, pineapple ring on top.",
   "Between batches, give the griddle 60-90 seconds to climb back to temp. Rest: zero minutes \u2014 smash burgers wait for no one."
  ],
  "products": [
   {
    "label": "Kiawe Lump Charcoal \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ]
 },
 "puertohawaii": {
  "title": "The Founder's Puerto Hawaii Lobster",
  "meta": "45 min with the salsa \u00b7 Intermediate \u00b7 1 lobster per person",
  "protein": "lobster",
  "cuts": [
   "Split & Grilled"
  ],
  "rigs": [
   "charcoal",
   "parrilla",
   "pitgrill"
  ],
  "intro": [
   "Puerto Nuevo is the lobster village south of Rosarito, and its method is the point: split spiny lobster flash-FRIED in bubbling fat until the meat browns and blisters, then stacked on the table with warm tortillas, refried beans, rice, and butter. The founder ate it there across years of Baja trips \u2014 and here's the secret that makes the fusion honest: Baja's bug and Hawaii's ula are the same animal. No claws, all tail, both shores.",
   "So this is that plate with Hawaii folded in. Garlic-shoyu butter instead of plain drawn butter. Coconut rice instead of Spanish. A salsa whose tomatoes, jalape\u00f1os, and pineapple went through kiawe smoke first. The refried beans stay exactly as they are \u2014 that's the Baja soul of the plate, and you don't fix soul."
  ],
  "pair": [
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "the Hawaii swap for Spanish rice"
   },
   {
    "t": "Refried Beans",
    "u": "https://www.simplyrecipes.com/recipes/refried_beans/",
    "d": "untouched - the Baja soul"
   }
  ],
  "specs": [
   {
    "l": "Tallow",
    "v": "350-375F in the pan, IR gun"
   },
   {
    "l": "Pull At",
    "v": "135-140F \u2014 past 140 it's rubber"
   },
   {
    "l": "Time",
    "v": "10-12 min fry + 45 min salsa smoke"
   },
   {
    "l": "Burn",
    "v": "Kiawe lump + chips over the pan"
   }
  ],
  "ing": [
   "2 spiny lobsters, split lengthwise, cleaned, patted VERY dry \u2014 wet meat spatters and steams",
   "Beef tallow, about 1/4 inch deep in the pan",
   "Garlic-shoyu butter: 1 stick butter + 3 crushed garlic cloves + 1 Tbsp shoyu + a splash of chili pepper water, melted together",
   "Kiawe-smoked molcajete salsa: 2 garlic cloves + 1 tsp coarse salt + a pinch of cumin, ground to a paste in the molcajete FIRST \u2014 then 4 halved Roma tomatoes, 2 whole jalape\u00f1os, and 2 thick pineapple rings (all smoked 45 min at 225-250F over kiawe) worked in until chunky. A squeeze of lime, rest an hour.",
   "The founder's pineapple pico (optional second topping \u2014 fresh-chopped, never in the molcajete): 250g Roma tomatoes, seeded + diced \u00b7 250g fresh pineapple, finely diced \u00b7 90g onion, diced \u00b7 20-25g jalape\u00f1o, finely minced \u00b7 12-14g fresh cilantro, chopped \u00b7 28-30g fresh lime juice \u00b7 5g kosher salt, then adjust",
   "Pico technique: the pineapple and the jalape\u00f1o go through kiawe smoke FIRST \u2014 ride them along in the same 45-minute session as the salsa vegetables \u2014 then cool and dice. Everything else stays raw and cold. The pineapple replaces tomato, it doesn't join it: total fruit stays at 500g, and the split slides to taste (300/200 tomato-forward if a batch reads sweet). If the onion bites too sharp, rinse it under cold water and drain well.",
   "Warm flour tortillas \u2014 a tall stack",
   "Refried beans and coconut rice",
   "Lime wedges + the pepper water bottle on the table"
  ],
  "steps": [
   "Salsa first (or the day before): tomatoes, jalape\u00f1os, and pineapple into kiawe smoke at 225-250F for 45 minutes. While they smoke, grind the salt, garlic, and cumin to a paste in the molcajete \u2014 the paste is the foundation, and the order is the technique. Work the smoked vegetables and pineapple into the paste until chunky, squeeze of lime, rest an hour minimum.",
   "Flat-top or big cast iron over kiawe lump, chips on the coals so smoke rolls over the pan. Tallow in \u2014 350-375F in the fat on the IR gun. Hotter scorches the tallow; cooler and the lobster soaks instead of fries.",
   "Lobster halves meat-side down into the tallow, 2-3 minutes \u2014 browned, blistered, edges crisping. This is the Puerto Nuevo move: it's a fry, not a grill.",
   "Flip shell-side down and spoon hot tallow over the meat for 2 more minutes. Pull at 135-140F.",
   "Off the fire, brush immediately with the garlic-shoyu butter \u2014 warm meat drinks it in.",
   "Serve village-style: everything on the table at once \u2014 tortilla, smear of beans, spoon of coconut rice, chunk of lobster, smoked salsa, a last drip of butter. The Puerto Nuevo rule holds: the lobster never touches a plate. Tortilla or nothing."
  ],
  "products": [
   {
    "label": "Kiawe Lump Charcoal \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ]
 },
 "smokedfish": {
  "title": "The Founder's Smoked Fish",
  "meta": "Brine + pellicle + 2-4 hrs smoke \u00b7 Easy \u00b7 Any firm fish",
  "protein": "salmon",
  "cuts": [
   "Candied Salmon / Salmon Jerky"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "offset",
   "gas"
  ],
  "intro": [
   "The house cure, refined over years of putting speared and caught fish into kiawe smoke. Three things matter and one of them matters most: a simple brine, a rinse at the salinity of the ocean the fish came from, and the pellicle \u2014 the tacky, glossy skin the fillet forms as it air-dries. The pellicle is the biggest thing. Smoke doesn't stick to wet fish; it slides off with the moisture. Give the fillet its pellicle and every minute in the smoke lands.",
   "The island finish is the founder's twist: a warm kiawe honey and shoyu baste painted on the moment the fish comes off the smoker \u2014 warm fish drinks it in \u2014 or a shoyu-ginger boost stirred straight into the brine. Kiawe honey comes from the blossoms of the same tree as the wood in your smoker. The tree flavors this fish twice."
  ],
  "pair": [
   {
    "t": "Furikake Rice",
    "u": "https://onolicioushawaii.com/furikake-rice/",
    "d": "if it makes it past snacking"
   },
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "for the full spread"
   }
  ],
  "specs": [
   {
    "l": "Pit",
    "v": "165-180F"
   },
   {
    "l": "Pull At",
    "v": "145F, flakes but still glistens"
   },
   {
    "l": "Time",
    "v": "Brine + pellicle + 2-4 hrs"
   },
   {
    "l": "Burn",
    "v": "Kiawe pellets, or chunks on a low fire"
   }
  ],
  "ing": [
   "2-4 lbs firm fish fillets, skin on - salmon, trout, marlin, ono, ahi",
   "Brine: 1 cup coarse salt + 1 cup sugar + 1 gallon filtered water, stirred until dissolved",
   "Rinse: sea salt + filtered water mixed to ocean salinity, about 1/2 cup per gallon - it should taste like the sea",
   "Island baste: 3 Tbsp kiawe honey (any raw honey works) + 1 Tbsp shoyu + 1 tsp grated ginger, warmed",
   "Or the brine boost: add 1/2 cup shoyu + 1/4 cup brown sugar + a smashed thumb of ginger + a strip of lemon peel to the gallon",
   "A cookie cooling rack and a fan on low - the pellicle station"
  ],
  "steps": [
   "Submerge the fillets in the cold brine, in the fridge: 4 hours for thin fillets, 6-8 for standard, 8-12 for thick slabs. Don't overshoot - past 12 hours it just gets saltier.",
   "Rinse in the ocean-salinity sea salt water, not fresh - fresh water pulls the cure back out of the surface unevenly. An ocean-strength rinse cleans the fillet without undoing the brine.",
   "The pellicle - the biggest thing: fillets on the cooling rack, fan on low, 1-2 hours until the surface turns tacky and glossy like lacquer. Smoke sticks to pellicle. Skip this and the flavor slides off with the moisture.",
   "Smoke at 165-180F until 145F internal - 2 to 4 hours depending on thickness. Thin blue smoke, never white.",
   "The moment it comes off, paint it with the warm honey-shoyu baste - the warm fish drinks it in and sets to a soft gloss as it cools.",
   "Cool completely before wrapping. Better the next day; keeps a week in the fridge. It will not last a week."
  ],
  "products": [
   {
    "label": "Kiawe Wood Pellets \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ]
 },
 "zarandeado": {
  "title": "The Founder's Zarandeado",
  "meta": "45 min \u00b7 Intermediate \u00b7 Feeds a crowd",
  "protein": "striper",
  "cuts": [
   "Whole Fish"
  ],
  "rigs": [
   "charcoal",
   "kamado",
   "parrilla",
   "pitgrill"
  ],
  "intro": [
   "This recipe brings together the founder's two loves: Baja and Hawaii. The Baja half comes from years of chasing zarandeado up and down the coast between spearfishing dives \u2014 charcoal grills in Rosarito, Playa de Tijuana, Ensenada, Popotla, and liveaboard boats anchored off the islands of the Sea of Cortez. The best night of it: a 40-pound white seabass, filleted on deck, one whole half laid over the fire \u2014 it took a few sets of helping hands to flip and baste it \u2014 and everyone standing around the grill with tongs, filling fresh tortillas straight off the grate.",
   "The Hawaii half is in the baste: shoyu, ginger, chili pepper water, and a guava lacquer to finish. And the wood is where the two loves turn out to be one \u2014 zarandeado is mesquite-coast cooking, and kiawe IS a mesquite. Same tree family, different shore. One fish, both coasts, one fire."
  ],
  "pair": [
   {
    "t": "Pico de Gallo",
    "u": "https://www.simplyrecipes.com/recipes/pico_de_gallo/",
    "d": "the table is not complete without it"
   },
   {
    "t": "Quick-Pickled Red Onions",
    "u": "https://www.loveandlemons.com/quick-pickled-onions/",
    "d": "with sliced cucumber - the cool crunch against the hot fish"
   },
   {
    "t": "Homemade Flour Tortillas",
    "u": "https://www.gimmesomeoven.com/homemade-flour-tortillas/",
    "d": "everyone with tongs, straight off the grill"
   }
  ],
  "specs": [
   {
    "l": "Pit",
    "v": "Moderate kiawe coal bed"
   },
   {
    "l": "Pull At",
    "v": "130-135F at the thickest point"
   },
   {
    "l": "Time",
    "v": "25-35 min, flip every 2-3"
   },
   {
    "l": "Burn",
    "v": "Kiawe lump + chunks, burned down to coals"
   }
  ],
  "ing": [
   "1 whole snapper, opakapaka, or white seabass (3-5 lbs), butterflied through the back \u2014 or one big slab of fillet",
   "Coarse sea salt \u2014 salt the fish an hour ahead",
   "A hinged fish basket (the zaranda) \u2014 non-negotiable for all the flipping",
   "Working baste (no sugar \u2014 it cannot burn): 1/2 cup mayonnaise + 2 Tbsp melted butter + 2 Tbsp shoyu + juice of 2 limes + 1 tsp grated ginger + 2 crushed garlic cloves + a good splash of chili pepper water",
   "Finishing lacquer: 1/2 cup guava jam + 2 Tbsp shoyu + juice of 1 lime, warmed until it pours thin",
   "Chili pepper water (make 2-3 days ahead): 10-15 Hawaiian chilies, halved + 1 1/2 cups boiling water + 1 Tbsp vinegar + 1 tsp coarse salt",
   "The spread: warm tortillas, pico de gallo, cucumber and red onion quick-pickled in lime, avocado, cilantro, lime wedges"
  ],
  "steps": [
   "Salt the fish an hour ahead. Whisk the working baste, warm the lacquer, and clamp the fish in the basket.",
   "Burn kiawe down to a moderate glowing bed \u2014 this is a patient cook, not a sear.",
   "Start flesh-side down 3-4 minutes to set a crust, then flip. From here: baste, flip every 2-3 minutes, baste again. Every flip, every time \u2014 that is the dish.",
   "The mayo baste browns deeper and deeper bronze and never burns. 25-35 minutes total, to 130-135F at the thickest point.",
   "The lacquer comes LAST: brush it on as the basket comes off the fire, then one 20-30 second kiss back over the coals to set it \u2014 watched the whole time. Sugar goes from lacquer to carbon in the time it takes to grab a beer.",
   "Serve it Baja-style: the basket opened right at the fire, everyone with tongs and a stack of warm tortillas."
  ],
  "products": [
   {
    "label": "Kiawe Lump Charcoal \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ]
 },
 "spg": {
  "title": "The Founder's SPG Chicken",
  "meta": "1.5 hrs \u00b7 Easy \u00b7 Serves 4",
  "protein": "chicken",
  "cuts": [
   "Whole Bird"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "offset",
   "gas"
  ],
  "intro": "This is the cook that started Kiawe Fire Co. One whole chicken, three seasonings, and the first bag of test pellets \u2014 the smoke was so clean and sweet it turned a backyard dinner into a business plan. No brine, no injection, no sauce. The wood is the recipe.",
  "ing": [
   "1 whole chicken (4\u20135 lb), spatchcocked",
   "2 Tbsp kosher salt",
   "1 Tbsp coarse black pepper",
   "1 Tbsp granulated garlic",
   "2 Tbsp olive oil"
  ],
  "steps": [
   "Spatchcock the bird: cut out the backbone with shears, flip, and press flat until the breastbone cracks. Pat completely dry.",
   "Rub all over with olive oil, then season every surface \u2014 under the wings, inside the legs.",
   "Run your fire at 375\u2013400\u00b0F. Bird skin-side up, legs toward the hotter zone.",
   "Lid closed until the breast reads 165\u00b0F and thighs 175\u00b0F, about 75\u201390 minutes.",
   "Rest 10 minutes, carve, pour the board juices back over."
  ],
  "products": [
   {
    "label": "Kiawe Wood Pellets \u2014 coming soon",
    "cart": "waitlist"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "huli": {
  "title": "Huli Huli Chicken",
  "meta": "45 min + marinade \u00b7 Easy \u00b7 Serves 4",
  "protein": "chicken",
  "cuts": [
   "Thighs (Huli Huli)"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "offset",
   "gas"
  ],
  "intro": "Born at a Hawaii fundraiser in 1955, huli huli chicken is the smell of every island roadside stand worth pulling over for. Huli means turn \u2014 the recipe is in the flipping, and the shoyu-pineapple glaze that caramelizes a little more with every huli.",
  "ing": [
   "3 lb chicken thighs, bone-in",
   "1/2 cup shoyu",
   "1/2 cup pineapple juice",
   "1/4 cup brown sugar",
   "2 Tbsp ketchup",
   "1 Tbsp grated ginger",
   "3 cloves garlic, crushed"
  ],
  "steps": [
   "Whisk the glaze. Reserve a third for basting; marinate the thighs in the rest, 2+ hours.",
   "Build a medium two-zone kiawe fire (or run 400\u00b0F with chunks or chips smoking).",
   "Start skin-side down over the cooler zone, lid closed, 5 minutes.",
   "Huli \u2014 and keep flipping every 4\u20135 minutes, basting on every turn.",
   "Pull at 175\u2013185\u00b0F when the glaze is dark and lacquered. Rest 5, scatter green onion."
  ],
  "products": [
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   },
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "kalua": {
  "title": "Kalua-Style Pulled Pork",
  "meta": "10+ hrs \u00b7 Intermediate \u00b7 Serves 10",
  "protein": "pork",
  "cuts": [
   "Butt / Shoulder (Kalua-style)"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "offset",
   "imu"
  ],
  "intro": "Kalua literally means 'to cook in the pit.' For centuries Hawaiians buried whole pigs over kiawe coals and hot stones, wrapped in banana leaves. This version gets you the same salt-smoke-and-time magic on a modern rig \u2014 and if you ever dig the real imu, you already own the right wood.",
  "ing": [
   "1 bone-in pork butt (8\u20139 lb)",
   "2\u20133 Tbsp coarse Hawaiian sea salt (alaea if you can find it)",
   "Banana leaves (optional but righteous)",
   "Steamed rice and shredded cabbage, to serve"
  ],
  "steps": [
   "Score the fat cap crosshatch. Season with the salt \u2014 that is the entire rub.",
   "Smoke at 225\u2013250\u00b0F until the bark sets, ~165\u00b0F internal, about 6 hours.",
   "Wrap in banana leaves then foil or butcher paper. Continue until the bone wiggles free at ~203\u00b0F.",
   "Rest one full hour, wrapped, in a cooler.",
   "Shred, season with its own juices and a pinch more salt. Serve over rice \u2014 or fold in wilted cabbage."
  ],
  "products": [
   {
    "label": "Kiawe Wood Pellets \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "ribs": {
  "title": "Hawaiian Guava Sticky Ribs",
  "meta": "5 hrs \u00b7 Intermediate \u00b7 Serves 4",
  "protein": "pork",
  "cuts": [
   "Baby Back Ribs (island glazed)"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "offset"
  ],
  "intro": "Guava grows wild across the islands and its jam belongs on ribs the way honey belongs on biscuits. Sweet kiawe smoke for four hours, guava lacquer for the last thirty minutes \u2014 the glaze goes on late because sugar burns and patience doesn't.",
  "ing": [
   "2 racks baby back ribs, membrane removed",
   "Rub: 2 Tbsp brown sugar, 1 Tbsp salt, 2 tsp pepper, 2 tsp granulated garlic, 1 tsp ground ginger",
   "Glaze: 1 cup guava jam or jelly, 2 Tbsp shoyu, 1 Tbsp rice vinegar, 1 tsp grated ginger"
  ],
  "steps": [
   "Rub the racks the night before, or an hour ahead minimum.",
   "Smoke at 225\u2013250\u00b0F, bone-side down, 4 to 4.5 hours \u2014 until the bark sets and the rack bends deep.",
   "Warm the glaze until pourable.",
   "Paint, cook 15 minutes, paint again, 15 more \u2014 glaze only lives in the last half hour.",
   "Pull when a probe slides between bones with no fight (~200\u00b0F). Rest 10, slice."
  ],
  "products": [
   {
    "label": "Kiawe Wood Pellets \u2014 coming soon",
    "cart": "waitlist"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "salmon": {
  "title": "Kiawe-Planked Salmon",
  "meta": "40 min \u00b7 Easy \u00b7 Serves 4",
  "protein": "salmon",
  "cuts": [
   "Fillet (plank)"
  ],
  "rigs": [
   "plank",
   "pellet",
   "charcoal",
   "kamado",
   "gas"
  ],
  "intro": "Plank cooking is the gentlest way to put wood flavor into fish \u2014 the board shields the delicate flesh from the grate while it smolders sweet kiawe smoke up through the fillet. Cedar made this method famous; kiawe makes it Hawaiian.",
  "ing": [
   "2 lb salmon fillet, skin on",
   "2 Tbsp shoyu",
   "2 Tbsp maple syrup",
   "1 tsp grated ginger",
   "Green onion and toasted sesame, to finish"
  ],
  "steps": [
   "Soak the kiawe plank one full hour \u2014 it should feel heavy.",
   "Whisk shoyu, maple, ginger; brush over the flesh.",
   "Grill at 375\u2013400\u00b0F indirect. Plank on grates 3 minutes until it crackles, then salmon on, skin-down, lid closed.",
   "Cook 25\u201340 minutes to 125\u2013135\u00b0F at the thickest point \u2014 pull when white beads just appear.",
   "Serve off the plank with green onion and sesame."
  ],
  "products": [
   {
    "label": "Kiawe Grilling Planks \u2014 coming soon",
    "cart": "waitlist"
   }
  ],
  "pair": [
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "the island default under fish"
   },
   {
    "t": "Lomi Lomi Salmon",
    "u": "https://onolicioushawaii.com/lomi-salmon/",
    "d": "cold, salty, traditional"
   },
   {
    "t": "Mango Slaw",
    "u": "https://www.loveandlemons.com/mango-slaw/",
    "d": "crunch and acid"
   }
  ]
 },
 "pineapple": {
  "title": "Smoked Pineapple",
  "meta": "1 hr \u00b7 Easy \u00b7 Serves 6",
  "intro": "The collision your grill has been waiting for: the islands' sweetest fruit and the islands' sweetest smoke. Dessert, salsa, burger topping \u2014 it refuses to stay in one lane.",
  "ing": [
   "1 ripe pineapple, peeled, cored, quartered lengthwise",
   "2 Tbsp brown sugar",
   "Pinch of sea salt",
   "Optional: li hing mui powder, vanilla ice cream"
  ],
  "steps": [
   "Dust the spears with brown sugar and salt.",
   "Smoke at 250\u00b0F over kiawe chips or chunks about an hour, turning once, until bronzed.",
   "Optional: 60 seconds over direct flame for char marks.",
   "Serve warm \u2014 over ice cream, chopped into salsa, or on a burger."
  ],
  "products": [
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "lilikoi": {
  "title": "Lilikoi-Glazed Duck Breast",
  "meta": "30 min \u00b7 Intermediate \u00b7 Serves 2",
  "protein": "duck",
  "cuts": [
   "Breast"
  ],
  "rigs": [
   "pellet",
   "charcoal",
   "kamado",
   "gas"
  ],
  "intro": "Duck breast is the steak of the bird world and lilikoi \u2014 passionfruit \u2014 is its island soulmate: tart enough to slice through the rich skin, floral enough to dance with sweet kiawe smoke. Wild birds especially deserve this treatment; they earned it the hard way.",
  "ing": [
   "2 duck breasts, skin on",
   "1/4 cup lilikoi (passionfruit) juice or pulp",
   "2 Tbsp honey",
   "1 Tbsp shoyu",
   "Coarse salt and cracked pepper"
  ],
  "steps": [
   "Score the skin in a tight crosshatch without cutting the meat. Salt both sides and rest uncovered in the fridge 1 hour to dry the skin.",
   "Simmer lilikoi, honey, and shoyu into a glaze that coats a spoon.",
   "Start the breasts skin-side down over medium heat and render slowly, 6\u20138 minutes, until the skin is deep gold and crisp \u2014 most of the cook happens on the skin.",
   "Flip, brush with glaze, finish 2\u20133 minutes to 135\u00b0F for medium-rare.",
   "Rest 5 minutes, slice thin, spoon over the remaining glaze."
  ],
  "products": [
   {
    "label": "Kiawe Wood Pellets \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "pulehu": {
  "title": "Pulehu Steak",
  "meta": "20 min \u00b7 Easy \u00b7 Serves 2",
  "protein": "beef",
  "cuts": [
   "Ribeye / NY Strip",
   "Tomahawk / Bone-In Ribeye",
   "Tri-Tip"
  ],
  "rigs": [
   "charcoal",
   "kamado",
   "offset",
   "pellet"
  ],
  "intro": "Pulehu means 'to broil over hot coals,' and it's how Hawaiian cowboys \u2014 the paniolo \u2014 have cooked beef for two hundred years: rock salt, cracked pepper, an open kiawe fire, and nothing to hide behind. The simplest recipe on this site and maybe the best argument for the wood.",
  "ing": [
   "2 thick steaks (ribeye, NY, or tri-tip)",
   "Coarse Hawaiian sea salt",
   "Cracked black pepper"
  ],
  "steps": [
   "Bring the steaks to room temperature. Season hard with salt and pepper \u2014 more than feels polite.",
   "Burn kiawe lump (with a chunk on top) down to glowing coals \u2014 no flame, all glow.",
   "Grill directly over the coals, flipping every 45 seconds, until a dark crust forms.",
   "Pull at 130\u2013135\u00b0F for medium-rare. On a pellet grill: run 225\u00b0F to 118\u00b0F, then sear wide open.",
   "Rest 5 minutes. Slice against the grain. Eat outside."
  ],
  "products": [
   {
    "label": "Kiawe Lump Charcoal \u2014 coming soon",
    "cart": "waitlist"
   },
   {
    "label": "Kiawe Splits \u2014 20 lb \u00b7 $79.95",
    "cart": "Kiawe Splits 20 lb"
   },
   {
    "label": "Kiawe Wood Chunks \u2014 from $54.95",
    "cart": "Kiawe Wood Chunks 10 lb"
   }
  ],
  "pair": [
   {
    "t": "Hawaiian Mac Salad",
    "u": "https://onolicioushawaii.com/hawaiian-mac-salad/",
    "d": "the plate-lunch essential"
   },
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "sweet counterpoint to the smoke"
   },
   {
    "t": "Grilled Pineapple Salsa",
    "u": "https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/",
    "d": "bright and smoky"
   }
  ]
 },
 "ahisear": {
  "title": "Poke-House Seared Ahi",
  "meta": "10 min \u00b7 Easy \u00b7 Serves 2",
  "protein": "ahi",
  "cuts": [
   "Steaks (seared rare)"
  ],
  "rigs": [
   "charcoal",
   "kamado",
   "gas",
   "pellet"
  ],
  "intro": "Every good fish counter in Hawaii sells seared ahi with a cold rare center, and the secret is violence: the hottest fire you can build, the shortest cook you can stand. A handful of kiawe chips thrown on right before the fish is the poke-house move.",
  "ing": [
   "2 ahi steaks, 1.5 inches thick, sashimi grade",
   "1 Tbsp neutral oil",
   "Coarse salt and pepper",
   "Shoyu, sliced green onion, and toasted sesame, to serve"
  ],
  "steps": [
   "Get the fire screaming \u2014 flames licking the grate. Throw a handful of kiawe chips on 60 seconds before the fish.",
   "Oil and season the steaks.",
   "Sear 60\u201390 seconds per side. The center stays cold and red \u2014 that's the point.",
   "Slice immediately, against the grain, half-inch thick.",
   "Shoyu, green onion, sesame. Serve over rice or eat standing at the cutting board like everyone actually does."
  ],
  "products": [
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ],
  "pair": [
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "the island default under fish"
   },
   {
    "t": "Lomi Lomi Salmon",
    "u": "https://onolicioushawaii.com/lomi-salmon/",
    "d": "cold, salty, traditional"
   },
   {
    "t": "Mango Slaw",
    "u": "https://www.loveandlemons.com/mango-slaw/",
    "d": "crunch and acid"
   }
  ]
 },
 "garlicshrimp": {
  "title": "North Shore Garlic Shrimp",
  "meta": "15 min \u00b7 Easy \u00b7 Serves 4",
  "protein": "shrimp",
  "cuts": [
   "Skewers"
  ],
  "rigs": [
   "charcoal",
   "kamado",
   "gas",
   "pellet"
  ],
  "intro": "The shrimp trucks of Oahu's North Shore made this dish world-famous from a gravel parking lot: shell-on shrimp drowning in garlic butter. Cooking it over live kiawe fire adds the one thing the trucks can't \u2014 island smoke.",
  "ing": [
   "2 lb large shrimp, shell on, deveined",
   "1 stick butter",
   "10 cloves garlic, chopped rough",
   "2 Tbsp olive oil",
   "1/2 tsp chili flake",
   "Salt, and lemon to finish"
  ],
  "steps": [
   "Skewer the shrimp. Melt the butter with garlic, oil, and chili in a pan at the edge of the grill \u2014 let it sizzle, not brown.",
   "Toss a handful of kiawe chips on the fire.",
   "Grill the skewers over high heat 2\u20133 minutes per side until opaque and C-shaped.",
   "Pull them straight into the garlic butter and toss hard.",
   "Salt, squeeze of lemon, serve over two scoops of rice like the trucks do."
  ],
  "products": [
   {
    "label": "Kiawe Wood Chips \u2014 5 lb \u00b7 $44.95",
    "cart": "Kiawe Wood Chips 5 lb"
   }
  ],
  "pair": [
   {
    "t": "Coconut Rice",
    "u": "https://www.recipetineats.com/coconut-rice/",
    "d": "the island default under fish"
   },
   {
    "t": "Lomi Lomi Salmon",
    "u": "https://onolicioushawaii.com/lomi-salmon/",
    "d": "cold, salty, traditional"
   },
   {
    "t": "Mango Slaw",
    "u": "https://www.loveandlemons.com/mango-slaw/",
    "d": "crunch and acid"
   }
  ]
 }
};
;
    var ARTICLE_HANDLES = {
    alohapastor:"alohapastor", smashburger:"smashburger", puertohawaii:"puertohawaii",
    smokedfish:"smokedfish", zarandeado:"zarandeado", spg:"spg",
    huli:"huli-huli-chicken", kalua:"kalua-style-pulled-pork", ribs:"hawaiian-guava-sticky-ribs",
    salmon:"kiawe-planked-salmon", pineapple:"smoked-pineapple",
    lilikoi:"lilikoi-glazed-duck-breast", pulehu:"pulehu-steak",
    ahisear:"poke-house-seared-ahi", garlicshrimp:"north-shore-garlic-shrimp"
  };
  var RIG_GUIDES = {
    pellet:"kiawe-pellets-on-a-pellet-grill", charcoal:"kiawe-on-a-charcoal-grill",
    kamado:"kiawe-on-a-kamado", offset:"kiawe-on-an-offset-smoker", gas:"kiawe-on-a-gas-grill",
    imu:"kiawe-imu-underground-oven", parrilla:"kiawe-on-a-parrilla",
    pitgrill:"kiawe-on-a-santa-maria-grill", pizzaoven:"kiawe-in-a-pizza-oven",
    plank:"kiawe-grilling-planks"
  };
  function openRecipe(key){
    var r = RECIPES[key];
    renderRecipeObj(r, ARTICLE_HANDLES[key]);
  }
  function openHouseRecipe(v){
    renderRecipeObj(houseRecipe(v));
  }
  function renderRecipeObj(r, articleHandle){
    if(!r) return;
    var b = '<h3>' + r.title + '</h3><div class="rmeta">' + r.meta + '</div>';
    if(articleHandle){
      b += '<p class="rpagelink"><a href="/blogs/signature-cooks/' + articleHandle + '">Open the full recipe page \u2192</a></p>';
    }
    if(mxR && RIG_GUIDES[mxR]){
      b += '<p class="rpagelink"><a href="/blogs/fire-school/' + RIG_GUIDES[mxR] + '">How to run this cook on your rig \u2192</a></p>';
    }
    var intros = (typeof r.intro === 'string') ? [r.intro] : (r.intro || []);
    intros.forEach(function(pg){ b += '<p class="rintro">' + pg + '</p>'; });
    if(r.pair && r.pair.length){
      b += '<h4>Round Out the Plate</h4><ul class="rpair">';
      r.pair.forEach(function(pl){ b += '<li><a href="' + pl.u + '" target="_blank" rel="noopener">' + pl.t + '</a>' + (pl.d ? ' \u2014 ' + pl.d : '') + '</li>'; });
      b += '</ul>';
    }
    if(r.specs && r.specs.length){
      b += '<div class="mx-specs" style="margin-top:1.2rem">';
      r.specs.forEach(function(s){ b += '<div class="mx-spec"><span>' + s.l + '</span><b>' + s.v + '</b></div>'; });
      b += '</div>';
    }
    b += '<h4>Ingredients</h4><ul>';
    r.ing.forEach(function(i){ b += '<li>' + i + '</li>'; });
    b += '</ul><h4>Cook Sequence</h4><ol>';
    r.steps.forEach(function(s){ b += '<li>' + s + '</li>'; });
    b += '</ol>';
    if(r.products && r.products.length){
      b += '<div class="rbuy"><h4>Stock the Fire</h4>';
      r.products.forEach(function(p){
        if(p.cart === 'waitlist'){
          b += '<button class="rbuy-btn" onclick="closeRecipe();joinWaitlistScroll()">' + p.label + ' — Join Waitlist</button>';
        } else {
          b += '<button class="rbuy-btn" onclick="addToCart(\'' + p.cart + '\')">' + p.label + ' — Add to Cart</button>';
        }
      });
      b += '</div>';
    }
    b += '<div class="rmodal-actions">' +
         '<form class="ract-form" onsubmit="return emailRecipe(event)">' +
         '<input type="email" id="rEm" placeholder="you@example.com" required>' +
         '<button class="ract" type="submit">Email Me the Printable</button></form>' +
         '<div class="ract-note" id="rEmailNote"></div></div>';
    document.getElementById('rmodalBody').innerHTML = b;
    document.getElementById('rmodalOverlay').classList.add('open');
  }
  var METHOD_PRODUCTS = {
    pellet:   [{label:"Kiawe Wood Pellets — coming soon", cart:"waitlist"},{label:"Kiawe Wood Chips — 5 lb · $44.95 (smoke tube)", cart:"Kiawe Wood Chips 5 lb"}],
    charcoal: [{label:"Kiawe Lump Charcoal — coming soon", cart:"waitlist"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    kamado:   [{label:"Kiawe Lump Charcoal — coming soon", cart:"waitlist"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    offset:   [{label:"Kiawe Splits — 20 lb · $79.95", cart:"Kiawe Splits 20 lb"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    parrilla: [{label:"Kiawe Lump Charcoal — coming soon", cart:"waitlist"},{label:"Kiawe Splits — 20 lb · $79.95", cart:"Kiawe Splits 20 lb"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    pitgrill: [{label:"Kiawe Lump Charcoal — coming soon", cart:"waitlist"},{label:"Kiawe Splits — 20 lb · $79.95", cart:"Kiawe Splits 20 lb"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    gas:      [{label:"Kiawe Wood Chips — 5 lb · $44.95", cart:"Kiawe Wood Chips 5 lb"},{label:"Kiawe Wood Chunks (foil-wrap them) — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    imu:      [{label:"Kiawe Splits — 20 lb · $79.95", cart:"Kiawe Splits 20 lb"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    pizzaoven:[{label:"Kiawe Splits — 20 lb · $79.95", cart:"Kiawe Splits 20 lb"},{label:"Kiawe Wood Chunks — from $54.95", cart:"Kiawe Wood Chunks 10 lb"}],
    plank:    [{label:"Kiawe Grilling Planks — coming soon", cart:"waitlist"}]
  };
  var HOUSE_FLAVORS = {
    island: {tag:"Island Shoyu-Guava", glaze:"Glaze: 1/2 cup guava jam + 2 Tbsp shoyu + 1 tsp grated ginger, warmed", finish:"Finish with sliced green onion and toasted sesame.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 2 Tbsp shoyu + 1 Tbsp grated ginger",
      origin:"This preparation comes from the sweet-savory heart of Hawaiian barbecue: shoyu (soy sauce) and guava, the flavor pair behind everything from huli huli chicken to plate-lunch teriyaki. Shoyu arrived with Japanese plantation workers in the 1880s and guava grows half-wild across the islands \u2014 together over kiawe wood smoke they define what locals mean when they say island-style."},
    huli:   {tag:"Huli Huli Glazed", glaze:"Glaze: 1/2 cup shoyu + 1/2 cup pineapple juice + 1/4 cup brown sugar + 1 Tbsp grated ginger + 2 Tbsp ketchup, reduced by half", finish:"Baste on every flip - huli means turn.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 1/4 cup pineapple juice + 2 Tbsp shoyu",
      origin:"Huli huli is Hawaii\u2019s most famous fire glaze \u2014 born at a 1955 farm fundraiser where chicken was flipped between two grills until the shoyu-pineapple baste turned to dark lacquer. Huli means turn, and the glaze has been escaping onto every meat the islands grill ever since. Over kiawe wood it caramelizes into exactly the sweet-smoky crust the roadside stands are famous for."},
    salt:   {tag:"Pulehu-Style", glaze:"No glaze - coarse Hawaiian sea salt and cracked pepper, and plenty of both", finish:"Finish with a squeeze of lemon and nothing else - the smoke is the sauce.", cure:"Cure: 3/4 cup coarse salt + 1/2 cup brown sugar + 1 Tbsp cracked pepper - the old-style salt-forward cure",
      origin:"Pulehu means to broil over hot coals, and it is the oldest fire cooking on the Hawaiian islands \u2014 the method of the paniolo, Hawaii's cowboys, who worked cattle a generation before the American West had them. Rock salt, cracked pepper, glowing kiawe coals, and nothing to hide behind: when the wood is this good, seasoning is a formality."},
    spicy:  {tag:"Chili-Pineapple", glaze:"Glaze: 2 Tbsp chili-garlic sauce + 1/4 cup pineapple juice + 1 Tbsp shoyu + 1 Tbsp brown sugar, reduced", finish:"Finish with chili flake, lime, and a little more glaze.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 1 Tbsp chili flake + 2 Tbsp honey",
      origin:"Modern island fusion: the sweet acidity of pineapple \u2014 the crop that built and broke Hawaiian agriculture \u2014 cut with chili heat, the way food trucks from Oahu's North Shore to Kona serve it today. The sugar caramelizes over hot kiawe wood into a sticky, smoky lacquer that no mainland barbecue sauce quite touches."},
    tonga:  {tag:"Tongan Sipi-Style Shoyu-Sugar", glaze:"Glaze: 1/4 cup shoyu + 1/4 cup brown sugar + 1 Tbsp grated ginger + 2 crushed garlic cloves, simmered to a loose syrup", finish:"Finish with sliced green onion and a last spoon of glaze - serve over rice or root vegetables, Sunday-feast style.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 2 Tbsp shoyu + 1 tsp ground ginger + cracked pepper",
      origin:"Tonga runs on sipi \u2014 fatty lamb ribs rendered slow over fire, then flashed with a shoyu-sugar glaze until the edges lacquer. It is the taste of the Tongan Sunday: church, then the umu, then a table that feeds the whole family and half the neighbors. The dark, sweet-salty glaze was born of trade-store staples and has become one of the Pacific's great barbecue signatures \u2014 and it behaves beautifully over kiawe coals."},
    tahiti: {tag:"Tahitian Vanilla-Lime", glaze:"Baste: 4 Tbsp melted butter + seeds of 1/2 vanilla bean (or 1 tsp vanilla bean paste) + zest and juice of 1 lime + a good pinch of sea salt", finish:"Spoon warm vanilla-lime butter over everything at the table - it should not work, and it absolutely does.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + seeds of 1 vanilla bean + zest of 2 limes",
      origin:"Tahiti grows the world's most prized vanilla \u2014 Vanilla tahitensis, hand-pollinated flower by flower on family plantations across the Society Islands \u2014 and French Polynesia has never treated it as a dessert-only spice. Vanilla meets lime and butter over fish and pork in fare kitchens from Papeete to the outer atolls. Against kiawe's naturally sweet smoke, the pairing tastes inevitable."},
    guam:   {tag:"Chamorro Finadene", glaze:"Finadene (table sauce - do not cook it): 1/2 cup shoyu + 1/4 cup lemon juice or white vinegar + 1 small onion, sliced paper-thin + 2-4 crushed hot chilies (donne' if you can get them)", finish:"Douse generously at the table - in a Chamorro barbecue, the finadene does the talking.", cure:"Cure: 3/4 cup salt + 1/2 cup brown sugar + 2 Tbsp shoyu + 1 tsp chili flake + cracked pepper", glazeStep:"No brushing on this one. Mix the finadene ahead so the onion softens, and serve it at the table - Chamorro barbecue keeps the fire simple and lets the sauce bring the heat and acid.",
      origin:"On Guam, barbecue is the fiesta \u2014 and no Chamorro fiesta plate is complete without finadene, the soy-citrus-chili sauce every family mixes to its own fiercely defended ratio. The meat comes off the fire simply seasoned, and the finadene hits it at the table: salt, sour, and chili heat all at once. It is the Marianas' answer to chimichurri, and kiawe smoke gives it exactly the char it wants to cling to."},
    samoa:  {tag:"Samoan Coconut-Cream", glaze:"Baste: 1/2 cup coconut cream + 1 small onion, finely grated + 1 tsp sea salt, warmed gently (never boiled)", finish:"Spoon warm coconut cream over the top and serve with taro or rice - palusami rules apply.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 1/3 cup coconut milk powder + cracked pepper",
      origin:"In Samoa the umu \u2014 the above-ground stone oven \u2014 anchors the Sunday to'ona'i feast, and coconut cream is its soul: pressed fresh from grated coconut and poured over everything from palusami parcels to fish straight off the stones. Rich, faintly sweet, and made for smoke. Basted over a kiawe fire it bastes, browns, and turns silk."},
    fiji:   {tag:"Fijian Lovo-Style Lemon-Herb", glaze:"Baste: juice of 2 lemons + 3 Tbsp melted butter + 2 crushed garlic cloves + a handful of chopped herbs (parsley, green onion, a little chili)", finish:"Serve on or wrapped in a banana leaf if you can get one - the aroma is half the dish.", cure:"Cure: 3/4 cup salt + 1/2 cup brown sugar + zest of 2 lemons + cracked pepper",
      origin:"Fiji's lovo is the earth oven of the feast day \u2014 chicken, fish, and root crops wrapped in banana leaves and buried over fire-heated stones until everything steams in its own smoky juices. The seasoning stays bright and simple: lemon, garlic, herbs, salt. Cooked over kiawe with a leaf wrap or a lemon-butter baste, it is the lovo's clean, green flavor without the shovel."},
    aotearoa:{tag:"Aotearoa M\u0101nuka-Honey", glaze:"Glaze: 1/3 cup m\u0101nuka honey (any raw bush honey works) + 2 Tbsp shoyu + 1 Tbsp cider vinegar + plenty of cracked pepper, warmed loose", finish:"Finish with flaky sea salt and one last thread of honey.", cure:"Cure: 1 cup brown sugar + 1/2 cup salt + 3 Tbsp m\u0101nuka honey + cracked pepper",
      origin:"In Aotearoa New Zealand, the M\u0101ori h\u0101ng\u012b buries the feast over fire-heated stones \u2014 steam, smoke, and patience \u2014 while m\u0101nuka, the native tea tree, doubles as the country's favorite smoking wood and the source of its most famous honey. Dark, resinous m\u0101nuka honey cut with soy and vinegar makes a glaze with real backbone. Kiawe and m\u0101nuka are kindred spirits: dense island hardwoods with a naturally sweet, clean burn."}
  };
  var PAIR_SETS = {
    plate: [{t:"Hawaiian Mac Salad", u:"https://onolicioushawaii.com/hawaiian-mac-salad/", d:"the plate-lunch essential"},
            {t:"Coconut Rice", u:"https://www.recipetineats.com/coconut-rice/", d:"sweet counterpoint to the smoke"},
            {t:"Grilled Pineapple Salsa", u:"https://www.simplyrecipes.com/recipes/grilled_pineapple_salsa/", d:"bright and smoky"}],
    fish:  [{t:"Coconut Rice", u:"https://www.recipetineats.com/coconut-rice/", d:"the island default under fish"},
            {t:"Lomi Lomi Salmon", u:"https://onolicioushawaii.com/lomi-salmon/", d:"cold, salty, traditional"},
            {t:"Mango Slaw", u:"https://www.loveandlemons.com/mango-slaw/", d:"crunch and acid"}],
    cure:  [{t:"Furikake Rice", u:"https://onolicioushawaii.com/furikake-rice/", d:"if it makes it past snacking"},
            {t:"Hawaiian Mac Salad", u:"https://onolicioushawaii.com/hawaiian-mac-salad/", d:"for the full spread"}]
  };
  function houseRecipe(v){
    var f = HOUSE_FLAVORS[v] || HOUSE_FLAVORS.island;
    var m = MX_METHODS[mxR];
    var style = (mxR==="plank") ? "plank" : mxP.style;
    var sN = mxS.name.replace(/\s*\([^)]*\)/g, "").trim();
    var cN = mxP.name.replace(/\s*\([^)]*\)/g, "").trim();
    var name = (cN.toLowerCase().indexOf(sN.toLowerCase()) >= 0) ? cN : sN + " " + cN;
    var isFish = (mxS.cat==="Ocean Fish" || mxS.cat==="Freshwater Fish" || mxS.cat==="Shellfish");
    var pit = mxP.pit, time = mxP.time;
    if(mxR==="plank" && mxP.style!=="plank"){ pit = "375-400F indirect, on the plank"; time = "Cook to temp, not the clock"; }
    var seo = "This " + f.tag.toLowerCase() + " " + name.toLowerCase() + " recipe is built for the " + m.name.toLowerCase() + " and 100% Hawaiian kiawe wood \u2014 the dense island hardwood behind traditional Hawaiian barbecue, prized for a hotter, cleaner burn and a mild, naturally sweet smoke that mainland woods like hickory and mesquite can\u2019t match. Cook it to " + mxP.internal.toLowerCase() + " and let the fire do the talking.";
    var ing = [], steps = [];
    if(style === "lowslow"){
      ing = [name, "Rub: 2 Tbsp coarse salt, 1 Tbsp cracked pepper, 1 Tbsp granulated garlic, 1 Tbsp brown sugar, 1 tsp ground ginger", f.glaze];
      steps = ["Rub generously the night before if you can, or an hour ahead minimum.",
               "Fire setup: " + m.setup[style] + " Hold the pit at " + mxP.pit + ".",
               "Cook undisturbed until " + mxP.internal + " - plan on " + mxP.time + ". Spritz with water or pineapple juice each hour after the first two.",
               (f.glazeStep || (v==="salt" ? "No glaze on this one - let the bark speak." : "Glaze in the last 30-60 minutes, in 2-3 thin coats. At 220 with no flame around, sugar can't burn - you glaze late for the bark's sake: painted early it steams off and the bark never sets; painted over set bark, it lacquers.")),
               "The move: " + mxP.note,
               f.finish + " Rest well before slicing or pulling."];
    } else if(style === "cure"){
      ing = [name, f.cure];
      steps = ["Cure overnight in the fridge, fully coated. Rinse and pat dry.",
               "Air-dry on a rack until the surface turns tacky - the pellicle is what smoke sticks to.",
               "Fire setup: " + m.setup[style] + " Hold " + mxP.pit + ".",
               "Smoke until " + mxP.internal + " - roughly " + mxP.time + ".",
               "The move: " + mxP.note,
               "Cool completely before storing. Better on day two."];
    } else if(style === "plank" || mxR === "plank"){
      ing = [name, "1 kiawe grilling plank, soaked 1 hour", f.glaze, "Salt, pepper, and lemon"];
      steps = ["Soak the plank a full hour - it should feel heavy.",
               (f.glazeStep ? "Season well. " + f.glazeStep : "Season, then brush with the glaze."),
               "Fire setup: " + m.setup["plank"],
               "Cook lid-closed to " + mxP.internal + " - check early; planked cooks are about temperature, not time.",
               "The move: " + mxP.note,
               f.finish + " Serve straight off the plank."];
    } else if(style === "roast"){
      ing = [name, "2 Tbsp coarse salt + 1 Tbsp cracked pepper + 1 Tbsp granulated garlic", "2 Tbsp olive oil or melted butter" + (isFish ? ", plus lemon" : ""), f.glaze];
      steps = ["Season all over" + (isFish ? " and inside the cavity" : "") + "; oil the surface.",
               "Fire setup: " + m.setup[style] + " Hold " + mxP.pit + ".",
               "Roast lid-closed to " + mxP.internal + " - about " + mxP.time + ".",
               (f.glazeStep || (v==="salt" ? "Skip the glaze - crisp skin is the prize." : "Glaze in the final 15 minutes, not sooner.")),
               "The move: " + mxP.note,
               f.finish + " Rest 10 minutes before carving."];
    } else {
      var revSear = /then\b.*sear/i.test(mxP.pit);
      ing = [name, "Coarse Hawaiian sea salt and cracked pepper", "1 Tbsp neutral oil", (v==="salt" ? "Lemon, to finish" : f.glaze)];
      if(revSear){
        steps = ["Bring to room temperature. Season harder than feels polite.",
                 "Fire setup: two zones - gentle smoke first, screaming sear to finish. For the sear phase: " + m.setup[style],
                 "The move: " + mxP.note + " Sear it dry - no glaze yet. Total cook runs about " + mxP.time + ", finishing at " + mxP.internal + ".",
                 (f.glazeStep || (v==="salt" ? "No glaze - pulehu means salt, pepper, fire, done." : "Brush the glaze on the moment it comes off the fire - sugar burns at sear temps, but the resting heat sets it into a lacquer.")),
                 f.finish + " It already rested before the sear, so slice within a few minutes" + (isFish ? "." : " - against the grain.")];
      } else {
        steps = ["Bring to room temperature. Season harder than feels polite.",
                 "Fire setup: " + m.setup[style],
                 "Cook hot and fast to " + mxP.internal + " - about " + mxP.time + ". Flip often for an even crust.",
                 (f.glazeStep || (v==="salt" ? "No glaze - pulehu means salt, pepper, fire, done." : "Brush with glaze in the last minute of the cook - any earlier and the sugar burns.")),
                 "The move: " + mxP.note,
                 f.finish + " Rest half as long as you cooked" + (isFish ? "." : ", then slice against the grain.")];
      }
    }
    var pair = (style==="cure") ? PAIR_SETS.cure : (isFish ? PAIR_SETS.fish : PAIR_SETS.plate);
    return {title: f.tag + " " + name,
            meta: mxP.time + " \u00b7 " + m.name + " \u00b7 House Recipe",
            intro: [f.origin, seo],
            pair: pair,
            specs: [{l:"Pit Temp", v:pit},{l:"Pull At", v:mxP.internal},{l:"Time", v:time},{l:"Burn", v:m.fuel}],
            ing: ing, steps: steps, products: METHOD_PRODUCTS[mxR] || []};
  }
  function closeRecipe(){
    document.getElementById('rmodalOverlay').classList.remove('open');
  }
  function printRecipe(){
    document.body.classList.add('print-recipe');
    window.print();
    setTimeout(function(){ document.body.classList.remove('print-recipe'); }, 500);
  }
  function emailRecipe(e){
    e.preventDefault();
    var em = document.getElementById('rEm').value;
    document.getElementById('rEmailNote').textContent = 'Sent to ' + em + ' \u2014 your printable recipe is on its way, plus one island recipe a week from The Weekly Fire. (Demo: wires to your email platform at launch.)';
    document.getElementById('rEm').value = '';
    return false;
  }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeRecipe(); });
  
/* Shopify port stubs: cart actions redirect to product pages */
function kfcProductUrl(name){
  var n = (name||'').toLowerCase();
  if(n.indexOf('chip')>=0) return '/products/kiawe-wood-chips';
  if(n.indexOf('chunk')>=0) return '/products/kiawe-wood-chunks';
  if(n.indexOf('split')>=0) return '/products/kiawe-splits';
  if(n.indexOf('pellet')>=0) return '/products/kiawe-wood-pellets';
  if(n.indexOf('charcoal')>=0) return '/products/kiawe-lump-charcoal';
  if(n.indexOf('plank')>=0) return '/products/kiawe-grilling-planks';
  return '/collections/all';
}
function addToCart(name){ window.location.href = kfcProductUrl(name); }
function joinWaitlistScroll(){ window.location.href = '/collections/all'; }
